import { useSettings } from "@ext/enterprise/components/admin/contexts/SettingsContext";
import { toCatalogRow } from "@ext/enterprise/components/admin/settings/resources/model/CatalogRow";
import type { AvailableCatalog } from "@ext/enterprise/types/AvailableCatalog";
import { useMemo } from "react";

export const useResourceCatalogs = (): Map<string, AvailableCatalog> => {
	const { settings } = useSettings();

	return useMemo(
		() =>
			new Map(
				(settings.resources ?? []).flatMap((resource) =>
					resource.catalog ? [[resource.id, resource.catalog] as const] : [],
				),
			),
		[settings.resources],
	);
};

export const useCatalogTitle = (repo: string): string => {
	const catalogs = useResourceCatalogs();
	return toCatalogRow(repo, catalogs.get(repo)).title;
};
